import axios from '../../axios';
import * as models from '../models';

// CreateRevisionRequests leaves the customer's revision requests on a quote's
// proofs. The quote key authorizes it.
export function CreateRevisionRequests(reqInit: models.IRevisionRequestsCreateRequest): Promise<models.RevisionRequestsCreateResponse> {
    const req = new models.RevisionRequestsCreateRequest(reqInit);
    return axios.post('/v2/revision-requests', req).then(resp => {
        const data = models.RevisionRequestsCreateResponse.fromJSON(resp.data);
        return data;
    });
}

// DeleteRevisionRequest cancels one request. The quote key authorizes it.
export function DeleteRevisionRequest(userEventID: string, quoteKey: string): Promise<void> {
    return axios.delete(`/v2/revision-requests/${userEventID}`, {
        params: { quoteKey },
    }).then(() => undefined);
}

// UpdateRevisionRequest restores a canceled request (active true).
export function UpdateRevisionRequest(userEventID: string, reqInit: models.IRevisionRequestUpdateRequest): Promise<void> {
    const req = new models.RevisionRequestUpdateRequest(reqInit);
    return axios.patch(`/v2/revision-requests/${userEventID}`, req).then(() => undefined);
}
